<ng-container *ngIf="graphData">
	<div
		*ngFor="let eachUnitGraph of graphData.progressDataClassroom; let i = index"
	>
			<app-component-loader [loading]="LoaderService.loadingProgressBarClassroom"></app-component-loader>
			<app-eachbar
				id="progress-bar-classroom"
				[data]="graphData.progressDataClassroom[this.classIndex]"
			></app-eachbar>
		</div>
</ng-container>
